<template>

  <Form
    :title="$t('Settings')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(settings)">
      <div class="form-group">
        <label>{{ $t('Defaut currency') }}</label>
        <select-currency v-model="settings.currency_default"></select-currency>
        <ValidateMessage :error="validateErrors['currency_default']" />
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="automerge"
            v-model="settings.automerge">
          <label
            class="form-check-label"
            for="automerge">
            {{ $t('Automatically unify') }}
            </label>
        </div>
        <ValidateMessage :error="validateErrors['settings.automerge']" />
        <p class="text-muted">{{ $t('Merge new applications with existing profiles automatically.') }}</p>
      </div>
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'
import SelectCurrency from '@/components/Fields/SelectCurrency'

export default {
  name: 'AccountProfile',
  components: {
    Form,
    SelectCurrency
  },
  data () {
    return {
      creating: false,
      loading: false,
      settings: {},
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getAccountSettings', this.account._id)
      .then(result => {
        this.settings = result.settings
        this.creating = false
      })
    },
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountSettings', {
        _id: this.account._id,
        settings: data
      })
      .then((result) => {
        this.settings = result.settings
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    setFile
    */
    setFile (media) {
      this.account.logo_media_url = media ? media.url : null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountSetting.vue